// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q4LR","content":"styles_content__2YgTV"};